// import React from "react";
import { seoConfig } from "@/config/seo.config";
import AboutUsContent from "./AboutUsContent";
import SEO from "@/components/SEO";

export default function AboutUs() {
  return (
    <> <SEO {...seoConfig.aboutus} />
    <div>
      <AboutUsContent />
    </div>
    </>
  );
}
